import { render, staticRenderFns } from "./labelShow.vue?vue&type=template&id=5652b5c2&scoped=true"
import script from "./labelShow.vue?vue&type=script&lang=js"
export * from "./labelShow.vue?vue&type=script&lang=js"
import style0 from "./labelShow.vue?vue&type=style&index=0&id=5652b5c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5652b5c2",
  null
  
)

export default component.exports